import config from 'modules/taboola-common-frontend-modules/authentication/config';
import { isIframeMode } from './isIframeMode';

export const isSeparateAppInstanceForbidden = isNonAuthAccess =>
    !isIframeMode() && window.location.origin === config.getIframeDomain() && !isNonAuthAccess;
